import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useLocale } from 'react-intlayer'
import { SupportView } from '@/components/support-view'

export const Route = createFileRoute('/support/success/')({ component: Page })
function Page() {
  const { locale } = useLocale()
  const navigate = useNavigate()
  return (
    <SupportView
      screen='success'
      locale={locale === 'en' ? 'en' : 'ja'}
      onBack={() => {
        void navigate({ to: '/support' })
      }}
    />
  )
}
